var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAppInitialized)?_c('router-view'):_vm._e(),_c('notifications',{attrs:{"position":"bottom right","data-test":"notifications","ignoreDuplicates":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }